module.exports = __webpack_public_path__ + "img/san.56a91c25.svg";